const actions = {
    // Orders
    STORE_CP_READ_ORDERS_REQUEST: 'STORE_CP_READ_ORDERS_REQUEST',
    STORE_CP_READ_ORDERS_SUCCESS: 'STORE_CP_READ_ORDERS_SUCCESS',
    STORE_CP_READ_ORDERS_ERROR: 'STORE_CP_READ_ORDERS_ERROR',

    STORE_CP_DELETE_ORDER_REQUEST: 'STORE_CP_DELETE_ORDER_REQUEST',
    STORE_CP_DELETE_ORDER_SUCCESS: 'STORE_CP_DELETE_ORDER_SUCCESS',
    STORE_CP_DELETE_ORDER_ERROR: 'STORE_CP_DELETE_ORDER_ERROR',
    STORE_CP_UPDATE_ORDER_REQUEST: 'STORE_CP_UPDATE_ORDER_REQUEST',
    STORE_CP_UPDATE_ORDER_SUCCESS: 'STORE_CP_UPDATE_ORDER_SUCCESS',
    STORE_CP_UPDATE_ORDER_ERROR: 'STORE_CP_UPDATE_ORDER_ERROR',

    // Categories
    STORE_CP_READ_CATEGORIES_REQUEST: 'STORE_CP_READ_CATEGORIES_REQUEST',
    STORE_CP_READ_CATEGORIES_SUCCESS: 'STORE_CP_READ_CATEGORIES_SUCCESS',
    STORE_CP_READ_CATEGORIES_ERROR: 'STORE_CP_READ_CATEGORIES_ERROR',

    STORE_CP_CREATE_CATEGORY_REQUEST: 'STORE_CP_CREATE_CATEGORY_REQUEST',
    STORE_CP_CREATE_CATEGORY_SUCCESS: 'STORE_CP_CREATE_CATEGORY_SUCCESS',
    STORE_CP_CREATE_CATEGORY_ERROR: 'STORE_CP_CREATE_CATEGORY_ERROR',

    STORE_CP_READ_CATEGORY_REQUEST: 'STORE_CP_READ_CATEGORY_REQUEST',
    STORE_CP_READ_CATEGORY_SUCCESS: 'STORE_CP_READ_CATEGORY_SUCCESS',
    STORE_CP_READ_CATEGORY_ERROR: 'STORE_CP_READ_CATEGORY_ERROR',

    STORE_CP_UPDATE_CATEGORY_REQUEST: 'STORE_CP_UPDATE_CATEGORY_REQUEST',
    STORE_CP_UPDATE_CATEGORY_SUCCESS: 'STORE_CP_UPDATE_CATEGORY_SUCCESS',
    STORE_CP_UPDATE_CATEGORY_ERROR: 'STORE_CP_UPDATE_CATEGORY_ERROR',

    STORE_CP_UPDATE_CATEGORY_FEATURED_REQUEST: 'STORE_CP_UPDATE_CATEGORY_FEATURED_REQUEST',
    STORE_CP_UPDATE_CATEGORY_FEATURED_SUCCESS: 'STORE_CP_UPDATE_CATEGORY_FEATURED_SUCCESS',
    STORE_CP_UPDATE_CATEGORY_FEATURED_ERROR: 'STORE_CP_UPDATE_CATEGORY_FEATURED_ERROR',

    STORE_CP_UPDATE_CATEGORY_HIDDEN_REQUEST: 'STORE_CP_UPDATE_CATEGORY_HIDDEN_REQUEST',
    STORE_CP_UPDATE_CATEGORY_HIDDEN_SUCCESS: 'STORE_CP_UPDATE_CATEGORY_HIDDEN_SUCCESS',
    STORE_CP_UPDATE_CATEGORY_HIDDEN_ERROR: 'STORE_CP_UPDATE_CATEGORY_HIDDEN_ERROR',

    STORE_CP_DELETE_CATEGORY_REQUEST: 'STORE_CP_DELETE_CATEGORY_REQUEST',
    STORE_CP_DELETE_CATEGORY_SUCCESS: 'STORE_CP_DELETE_CATEGORY_SUCCESS',
    STORE_CP_DELETE_CATEGORY_ERROR: 'STORE_CP_DELETE_CATEGORY_ERROR',

    STORE_CP_REARRANGE_CATEGORY: 'STORE_CP_REARRANGE_CATEGORY',
    STORE_CP_UPDATE_CATEGORY_POSITION_REQUEST: 'STORE_CP_UPDATE_CATEGORY_POSITION_REQUEST',
    STORE_CP_UPDATE_CATEGORY_POSITION_SUCCESS: 'STORE_CP_UPDATE_CATEGORY_POSITION_SUCCESS',
    STORE_CP_UPDATE_CATEGORY_POSITION_ERROR: 'STORE_CP_UPDATE_CATEGORY_POSITION_ERROR',

    STORE_CP_INIT_CATEGORY: 'STORE_CP_INIT_CATEGORY',
    STORE_CP_INIT_COUPON: 'STORE_CP_INIT_COUPON',
    STORE_CP_SET_SELECTED_ITEMS: 'STORE_CP_SET_SELECTED_ITEMS',
    STORE_CP_SET_ALL_ITEM_IDS: 'STORE_CP_SET_ALL_ITEM_IDS',
    STORE_CP_SET_PRODUCT_FEATURED: 'STORE_CP_SET_PRODUCT_FEATURED',
    STORE_CP_SET_PRODUCT_HIDDEN: 'STORE_CP_SET_PRODUCT_HIDDEN',

    STORE_CP_READ_PAGE_LIST_REQUEST: "STORE_CP_READ_PAGE_LIST_REQUEST",
    STORE_CP_READ_PAGE_LIST_SUCCESS: "STORE_CP_READ_PAGE_LIST_SUCCESS",
    STORE_CP_READ_PAGE_LIST_ERROR: "STORE_CP_READ_PAGE_LIST_ERROR",

    STORE_CP_CREATE_PAGE_REQUEST: "STORE_CP_CREATE_PAGE_REQUEST",
    STORE_CP_CREATE_PAGE_SUCCESS: "STORE_CP_CREATE_PAGE_SUCCESS",
    STORE_CP_CREATE_PAGE_ERROR: "STORE_CP_CREATE_PAGE_ERROR",

    STORE_CP_READ_PAGE_REQUEST: "STORE_CP_READ_PAGE_REQUEST",
    STORE_CP_READ_PAGE_SUCCESS: "STORE_CP_READ_PAGE_SUCCESS",
    STORE_CP_READ_PAGE_ERROR: "STORE_CP_READ_PAGE_ERROR",

    STORE_CP_UPDATE_PAGE_REQUEST: "STORE_CP_UPDATE_PAGE_REQUEST",
    STORE_CP_UPDATE_PAGE_SUCCESS: "STORE_CP_UPDATE_PAGE_SUCCESS",
    STORE_CP_UPDATE_PAGE_ERROR: "STORE_CP_UPDATE_PAGE_ERROR",

    STORE_CP_DELETE_PAGE_REQUEST: "STORE_CP_DELETE_PAGE_REQUEST",
    STORE_CP_DELETE_PAGE_SUCCESS: "STORE_CP_DELETE_PAGE_SUCCESS",
    STORE_CP_DELETE_PAGE_ERROR: "STORE_CP_DELETE_PAGE_ERROR",

    STORE_CP_INIT_PAGE: "STORE_CP_INIT_PAGE",

    // COUPONS
    STORE_CP_READ_COUPON_LIST_REQUEST: "STORE_CP_READ_COUPON_LIST_REQUEST",
    STORE_CP_READ_COUPON_LIST_SUCCESS: "STORE_CP_READ_COUPON_LIST_SUCCESS",
    STORE_CP_READ_COUPON_LIST_ERROR: "STORE_CP_READ_COUPON_LIST_ERROR",

    STORE_CP_CREATE_COUPON_REQUEST: "STORE_CP_CREATE_COUPON_REQUEST",
    STORE_CP_CREATE_COUPON_SUCCESS: "STORE_CP_CREATE_COUPON_SUCCESS",
    STORE_CP_CREATE_COUPON_ERROR: "STORE_CP_CREATE_COUPON_ERROR",

    STORE_CP_READ_COUPON_REQUEST: "STORE_CP_READ_COUPON_REQUEST",
    STORE_CP_READ_COUPON_SUCCESS: "STORE_CP_READ_COUPON_SUCCESS",
    STORE_CP_READ_COUPON_ERROR: "STORE_CP_READ_COUPON_ERROR",

    STORE_CP_UPDATE_COUPON_REQUEST: "STORE_CP_UPDATE_COUPON_REQUEST",
    STORE_CP_UPDATE_COUPON_SUCCESS: "STORE_CP_UPDATE_COUPON_SUCCESS",
    STORE_CP_UPDATE_COUPON_ERROR: "STORE_CP_UPDATE_COUPON_ERROR",

    STORE_CP_DELETE_COUPON_REQUEST: "STORE_CP_DELETE_COUPON_REQUEST",
    STORE_CP_DELETE_COUPON_SUCCESS: "STORE_CP_DELETE_COUPON_SUCCESS",
    STORE_CP_DELETE_COUPON_ERROR: "STORE_CP_DELETE_COUPON_ERROR",

    STORE_CP_FETCH_CATEGORY_PRODUCT_DETAILS_REQUEST: 'STORE_CP_FETCH_CATEGORY_PRODUCT_DETAILS_REQUEST',
    STORE_CP_FETCH_CATEGORY_PRODUCT_DETAILS_ERROR: 'STORE_CP_FETCH_CATEGORY_PRODUCT_DETAILS_ERROR',

    // Reset
    STORE_CP_RESET_ALL: 'STORE_CP_RESET_ALL',

    // Orders
    readOrderList: request => ({
        type: actions.STORE_CP_READ_ORDERS_REQUEST,
        request,
    }),

    deleteOrder: id => ({
        type: actions.STORE_CP_DELETE_ORDER_REQUEST,
        id,
    }),
    updateOrder: (id, request) => ({
        type: actions.STORE_CP_UPDATE_ORDER_REQUEST,
        id,
        request, // {status:string, remarks:string}
    }),

    // Category
    readCategoryList: () => ({
        type: actions.STORE_CP_READ_CATEGORIES_REQUEST,
    }),
    createCategory: request => ({
        type: actions.STORE_CP_CREATE_CATEGORY_REQUEST,
        request,
    }),
    readCategory: id => ({
        type: actions.STORE_CP_READ_CATEGORY_REQUEST,
        id,
    }),
    updateCategory: (id, request) => ({
        type: actions.STORE_CP_UPDATE_CATEGORY_REQUEST,
        id,
        request,
    }),
    updateCategoryFeatured: (id, value) => ({
        type: actions.STORE_CP_UPDATE_CATEGORY_FEATURED_REQUEST,
        id,
        value,
    }),
    updateCategoryHidden: (id, value) => ({
        type: actions.STORE_CP_UPDATE_CATEGORY_HIDDEN_REQUEST,
        id,
        value,
    }),
    deleteCategory: id => ({
        type: actions.STORE_CP_DELETE_CATEGORY_REQUEST,
        id,
    }),
    rearrangeCategory: (oldIndex, newIndex) => ({
        type: actions.STORE_CP_REARRANGE_CATEGORY,
        oldIndex,
        newIndex,
    }),
    updateCategoryPositions: () => ({
        type: actions.STORE_CP_UPDATE_CATEGORY_POSITION_REQUEST,
    }),
    initCategory: category => ({
        type: actions.STORE_CP_INIT_CATEGORY,
        category,
    }),
    setSelectedItems: selectedItems => ({
        type: actions.STORE_CP_SET_SELECTED_ITEMS,
        selectedItems,
    }),

    onFeatureToggle: (id, value) => ({
        type: actions.STORE_CP_SET_PRODUCT_FEATURED,
        id,
        value,
        key: 'is_featured',
    }),
    onHiddenToggle: (id, value) => ({
        type: actions.STORE_CP_SET_PRODUCT_HIDDEN,
        id,
        value,
        key: 'is_hidden',
    }),

    // Category
    readPageList: () => ({
        type: actions.STORE_CP_READ_PAGE_LIST_REQUEST,
    }),
    createPage: request => ({
        type: actions.STORE_CP_CREATE_PAGE_REQUEST,
        request,
    }),
    readPage: id => ({
        type: actions.STORE_CP_READ_PAGE_REQUEST,
        id,
    }),
    updatePage: (id, request) => ({
        type: actions.STORE_CP_UPDATE_PAGE_REQUEST,
        id,
        request,
    }),
    deletePage: id => ({
        type: actions.STORE_CP_DELETE_PAGE_REQUEST,
        id,
    }),
    initPage: page => ({
        type: actions.STORE_CP_INIT_PAGE,
        page,
    }),

    // Coupons
    readCouponList: request => ({
        type: actions.STORE_CP_READ_COUPON_LIST_REQUEST,
        request,
    }),
    createCoupon: request => ({
        type: actions.STORE_CP_CREATE_COUPON_REQUEST,
        request,
    }),
    initCoupon: coupon => ({
        type: actions.STORE_CP_INIT_COUPON,
        coupon,
    }),
    readCoupon: id => ({
        type: actions.STORE_CP_READ_COUPON_REQUEST,
        id,
    }),
    updateCoupon: (id, request) => ({
        type: actions.STORE_CP_UPDATE_COUPON_REQUEST,
        id,
        request,
    }),
    deleteCoupon: id => ({
        type: actions.STORE_CP_DELETE_COUPON_REQUEST,
        id,
    }),

    fetchCategoryProductDetails: productIds => ({
        type: actions.STORE_CP_FETCH_CATEGORY_PRODUCT_DETAILS_REQUEST,
        productIds,
    }),

    // Reset
    resetAll: () => ({
        type: actions.STORE_CP_RESET_ALL,
    }),
};
export default actions;
